export const SET_SUPPORT_TICKETS_COUNT = "NOTOFOCATIONS:SET_SUPPORT_TICKETS_COUNT"
export const DECREMENT_SUPPORT_TICKETS_COUNT = "NOTOFOCATIONS:DECREMENT_SUPPORT_TICKETS_COUNT"
export const HANDLE_SUPPORT_DRAWER = "SUPPORT:HANDLE_SUPPORT_DRAWER"
